import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import Menu from './Menu';
import PopUp from './PopUp';
import Body from './Body';
import Content from './Content';

import './styles.css';

class MainLayout extends Component {
	render() {
		const { children } = this.props;
		return <div className="main-layout">{children}</div>;
	}
}
MainLayout.propTypes = {
	children: PropTypes.node
};

Object.assign(MainLayout, {
	Menu,
	Body,
	PopUp,
	Header,
	Content
});

export default MainLayout;
